/*===============================================================================================
 正規表現集
  * 正規表現でのフォーム検証ルール（Validators.pattern）を定義する際に参照する。

  * 下記のようにcomponent等でインポートして、参照できる。
    import * as REGEXP from '../../share/validate/regexp';

    (記載例)
      searchDealercode = new FormControl('', [
        Validators.pattern(REGEXP.POSTCODE)
      ]);

  * 必要に応じて追加する。
===============================================================================================*/
export const REGEXP = {
  // 郵便番号のみ許可
  POSTCODE: new RegExp(`^\\d{3}-\\d{4}$`),
  // 郵便番号(ハイフンなし)のみ許可
  POSTCODE_WITHOUT_HYPHEN: new RegExp(`^\\d{7}$`),
  // 電話番号のみ許可(10桁判定は非対応)
  TEL: new RegExp(`^\\d{2,5}-\\d{1,4}-\\d{3,4}$`),
  // FAX番号のみ許可(10桁判定は非対応)
  FAX: new RegExp(`^\\d{2,5}-\\d{1,4}-\\d{3,4}$`),
  // 半角英数のみ許可(空文字禁止)
  HALF_WIDTH_CHAR: new RegExp(`^[A-Za-z0-9]+$`),
  // 半角英数,ハイフン,アンダーバーのみ許可(空文字禁止)
  HALF_WIDTH_CHAR_UNDERSCORE_HYPHEN: new RegExp(`^[A-Za-z0-9_-]+$`),
  // 半角英数,アンダーバーのみ許可(空文字禁止)
  HALF_WIDTH_CHAR_UNDERSCORE: new RegExp(`^[A-Za-z0-9_]+$`),
  // 英数字混合のみ許可(英字、数字それぞれ1文字以上含まれているか)
  PASSWORD: new RegExp(`^[a-z0-9_]+$`),
  // 半角数字のみ許可(空文字禁止)
  ONLY_NUMBER: new RegExp(`^[0-9]+$`),
};
